var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAhogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4586 17.4409C29.3943 17.4325 29.3304 17.4272 29.2677 17.4262C29.2677 17.4262 29.2381 17.3032 29.1827 17.0917C29.3937 15.5781 29.4412 13.7159 29.0951 12.0441C29.0951 12.0441 30.0585 9.03811 27.8907 6.25423C26.1657 4.03852 23.8782 4.63096 23.8782 4.63096L24.1087 4.97545C23.1655 3.89608 21.0917 2.43055 17.0855 3.22821C17.0855 3.22821 13.3119 3.90822 12.2885 3.04145L13.2085 4.92111C13.2085 4.92111 10.4125 5.39696 8.24585 4.33184C8.95593 6.85406 10.1609 8.66355 11.5926 9.8996C10.0975 13.1393 10.9269 16.7018 10.9269 16.7018C10.9269 16.8917 10.9453 17.1692 10.9759 17.5005L10.9664 17.4288C10.8535 17.4214 10.738 17.4251 10.6214 17.4409C9.66812 17.5681 8.99866 18.4438 9.1258 19.3971L9.40013 21.4529C9.52727 22.4062 10.403 23.0757 11.3563 22.9485C11.465 22.9343 11.5694 22.91 11.6696 22.8768V22.8731C11.8474 24.1762 12.2937 26.8086 13.0692 27.5108C13.0692 27.5108 16.4951 31 20.141 31C23.7869 31 26.8562 27.6617 26.8562 27.6617C27.7509 26.8983 28.2236 24.0464 28.384 22.8678C28.4922 22.9053 28.6056 22.9322 28.7232 22.948C29.6765 23.0752 30.5522 22.4057 30.6794 21.4524L30.9537 19.3966C31.0808 18.4433 30.4114 17.5675 29.4581 17.4404L29.4586 17.4409Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8856 6.82238C27.2925 6.07727 26.6305 5.67053 26.0247 5.45503C25.2107 5.1657 24.499 5.24893 24.033 5.29798C24.0016 5.30145 23.9707 5.30442 23.9403 5.30789C23.7559 5.13994 23.5634 4.97992 23.3801 4.84666C22.7084 4.35768 20.9594 3.34554 17.5109 3.98067C17.5109 3.98067 13.8877 4.61926 12.9051 3.80529L13.7885 5.57046C13.7885 5.57046 11.1039 6.01782 9.02356 5.01757C11.5972 13.9628 20.9513 13.3609 23.2241 10.272C23.2241 10.272 23.8836 12.6946 29.0415 12.2596C29.0415 12.2596 29.9665 9.43669 27.8851 6.82238H27.8856Z",
    fill: "#F5FBFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7557 12.1332C29.1147 13.922 29.0352 15.9298 28.7924 17.4897C28.6208 18.5902 28.2532 21.5099 28.1315 22.3941C28.1315 22.3941 27.6926 26.7125 26.5954 27.6775C26.5954 27.6775 23.6327 31 20.1145 31C16.5963 31 13.2893 27.5274 13.2893 27.5274C12.2833 26.5881 11.8505 22.1746 11.8505 22.1746C11.7487 21.4333 11.2212 17.8005 11.2212 16.7699C11.2212 16.7699 10.4213 13.2243 11.8637 10",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7082 6.27695C24.7082 6.27695 23.1069 2.43626 17.2279 3.60601C17.2279 3.60601 13.5581 4.26734 12.5627 3.42439L13.4575 5.25239C13.4575 5.25239 10.7388 5.71568 8.63123 4.68034",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8337 4.97016C23.8337 4.97016 26.0583 4.394 27.736 6.54881C29.8436 9.25618 28.9073 12.1795 28.9073 12.1795C23.6829 12.63 23.0149 10.1212 23.0149 10.1212",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63135 4.67969C11.2382 13.9433 20.7127 13.32 23.0147 10.1211",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0851 10.9659C11.7532 13.5835 11.2386 16.7101 11.2386 16.7101",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0739 12.2333C28.2467 13.9433 29.0747 17.4136 29.0747 17.4136C29.1363 17.4151 29.1984 17.4198 29.2605 17.428C30.1876 17.5516 30.8386 18.4033 30.715 19.3304L30.4482 21.3297C30.3245 22.2568 29.4729 22.9079 28.5458 22.7842C28.4314 22.7688 28.3211 22.7427 28.2159 22.7062",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7133 22.2351V19.2891C20.7133 18.5057 21.2119 17.809 21.9538 17.5571L22.1785 17.4776C23.1015 17.1641 24.1132 17.2513 24.9685 17.7192L25.5005 18.0101",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9553 17.7284L18.2175 17.4776C17.2945 17.1641 16.2828 17.2513 15.4275 17.7192L14.8955 18.0101",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9619 22.7153C11.8644 22.7471 11.7623 22.7707 11.6571 22.7851C10.7301 22.9087 9.8784 22.2577 9.75475 21.3306L9.48796 19.3312C9.36432 18.4041 10.0154 17.5525 10.9425 17.4288C11.0558 17.414 11.1682 17.4104 11.278 17.417",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4423 18.8983L15.9156 21.4249",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6033 18.8983L22.0766 21.4249",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4423 21.4247L15.9156 18.898",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6033 21.4247L22.0766 18.898",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8218 25.1535H23.9683",
    stroke: "#228C80",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1096 27.2974C21.899 27.2974 22.5389 26.3376 22.5389 25.1535H19.6803C19.6803 26.3376 20.3202 27.2974 21.1096 27.2974Z",
    stroke: "#228C80"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30C17 32 16.2727 36 13.3636 36C10.4545 36 7.90909 36 7 36",
    stroke: "#228C80"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C24 32 24.7273 36 27.6364 36C30.5455 36 33.0909 36 34 36",
    stroke: "#228C80"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34.4996C23 35.8807 21.8807 37 20.4996 37C19.1184 37 18 35.8807 18 34.4996C18 33.1184 19.1193 32 20.4996 32C21.8798 32 23 33.1193 23 34.4996Z",
    fill: "#F9839A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5228 33.5944L19.5944 35.5228",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5226 35.5232L19.5942 33.5948",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAhogo);
export default __webpack_public_path__ + "static/media/Ic_ahogo.be85a11031f5d3e6264b015b584e2fc4.svg";
export { ForwardRef as ReactComponent };